import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TrendingSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TrendingSVG;
